import { useCallback, useEffect, useState } from "react";
import NitroService from "../../utils/nitro.service";

import AutocompleteMulti from "../AutocompleteMulti";
import { useIsComponentMounted } from "../../hooks/useIsComponentMounted";

const StateMultiFilter = ({
  value,
  setValue,
  width,
  size,
}: {
  value: string[];
  setValue: (value: string[]) => void;
  width?: number;
  size?: "small" | "medium";
}) => {
  const isComponentMounted = useIsComponentMounted();
  const [records, setRecords] = useState<string[]>([]);
  const load = useCallback(async () => {
    const result = await NitroService.getStates();
    setRecords(result.map((r) => r.name));
  }, []);

  useEffect(() => {
    if (!isComponentMounted) return;
    load();
  }, [isComponentMounted, load]);

  const sort = (states: string[]) => {
    return states.sort((a, b) => a.localeCompare(b));
  };

  return (
    <div style={{ width, minWidth: width }}>
      <AutocompleteMulti
        size={size}
        records={records}
        placeholder="States"
        value={sort(value)}
        setValue={(v: any) => setValue(v)}
      />
    </div>
  );
};

export default StateMultiFilter;
